// extracted by mini-css-extract-plugin
export default {"line":"Transactions_line__d24LU","cell":"Transactions_cell__zkHBN"};